import { FormField, validUserTypes } from './form-types';
import { countries } from '../../tools/countries-data';
import { Show } from 'solid-js';

type UserTypeMap = {
    [key: string]: string;
};

type GetCountryOptionsProps = {
    localize: (slug: string, defaultValue: string) => string;
    translations: { [ key: string ]: string; };
    currentSelectCountryCode: string | undefined;
    isAtosCare: boolean;
};

export const getPlaceholder = (field: FormField, localize: (slug: string, defaultValue: string) => string) => {
    let slug = field.slug;

    switch (field.slug) {
        case 'firstname':
            slug = 'first-name';
            break;
        case 'lastname':
            slug = 'last-name';
            break;
        case 'zip':
            slug = 'postal-code';
            break;
        case 'userType':
            slug = 'user-type';
            break;
        case 'communicationPreference':
            slug = 'communication-preference';
            break;
    }
    
    let placeholder = localize(slug, field.name);
    if (field.required) {
        placeholder = `${localize(slug, field.name)}*`;
    }
    return placeholder;
};

export const getCountryOptions = (props: GetCountryOptionsProps) => {
    const UK = countries.find((country) => country.code === 'GB');

    return (
        <>
            <option value="" disabled selected>
                <Show 
                    when={props.translations['select-country']}
                    fallback={props.localize('country', 'Country')} /* The old way */
                >
                    {props.localize('select-country', 'Select country')}
                </Show>
            </option>

            {/* If the user is from AtosCare, place UK option additionally at the top */}
            {props.isAtosCare && UK && (
                <option selected={UK.code === props.currentSelectCountryCode} value={UK.code}>{UK.name}</option>
            )}
            
            {countries.map((country) => (
                <option selected={country.code === props.currentSelectCountryCode} value={country.code}>{country.name}</option>
            ))}
        </>
    );
};

export const getUserTypeOptions = (localize: (slug: string, defaultValue: string) => string, translations: { [ key: string ]: string; }) => {
    const userTypeMap: UserTypeMap = {
        'HCP': localize('i-am-a-healthcare-professional' ,'I am a Healthcare Professional'),
        'Other': localize('other' ,'Other'),
    };

    return (
        <>
            <option value="" disabled selected>
                <Show 
                    when={translations['select-type-of-user']}
                    fallback={localize('user-type', 'User type')} /* The old way */
                >
                    {`${localize('select-type-of-user', 'Select type of user')}*`}
                </Show>
            </option>
            {validUserTypes.map((userType) => (
                <option value={userType}>{localize(userType, userTypeMap[userType])}</option>
            ))}
        </>
    );
};
